


// export const formatoHorasDetallado = (horaInicio, horaFinal) => {
//     const inicio = new Date(horaInicio);
//     const final = new Date(horaFinal);
//     const formato = (fecha) =>
//         fecha.getHours().toString().padStart(2, '0') + ':' +
//         fecha.getMinutes().toString().padStart(2, '0');
//     const duracionHoras = (final - inicio) / (1000 * 60 * 60);
//     return `${formato(inicio)}/${formato(final)} (${duracionHoras}h)`;
// }


export const formatoHorasDetallado = (horaInicio, horaFinal) => {
    const inicio = new Date(horaInicio);
    const final = new Date(horaFinal);

    if (isNaN(inicio) || isNaN(final)) {
        return 'Fecha Invalidad';
    }

    if (final < inicio) {
        return 'Fecha Invalidad';
    }

    const duracionMs = final - inicio;
    const duracionMin = Math.floor(duracionMs / (1000 * 60));
    const horas = Math.floor(duracionMin / 60);
    const minutos = duracionMin % 60;
    const duracionTexto = `${horas}h ${minutos}min`;

    return `${duracionTexto}`;
};